import React from 'react'
import { Wrapper } from './style'
import { Link, useLocation } from 'react-router-dom'
import { ModalButton } from 'src/components/Global/Button/Button'
import { generalSVg } from 'src/assets'
const PlanOnboarding = () => {
  let location = useLocation()
  return (
    <Wrapper>
      <form className="content">
        <div className="top-form">
          <h2 className="title on">General Savings</h2>
          <img src={generalSVg} alt="onboard" className="img-center" />
          <h3>Save for your periodic goals</h3>
          <ul>
            <li>
              Save randomly for any specific period of time of your choice
              between 1 to 12 months.
            </li>
            <li>
              Premature withdrawals are allowed only mid-way through the
              selected duration.
            </li>
          </ul>
        </div>
        <div>
          <Link to={`/plan/name`} state={{ backgroundLocation: location }}>
            <ModalButton className="button">Get Started</ModalButton>
          </Link>
        </div>
      </form>
    </Wrapper>
  )
}

export { PlanOnboarding }
